import React from 'react';

export default (Child, Wrapper, passProps = false) => {
    const wrapped = (props) => {
        const passed = passProps ? props : {}
        return <Wrapper childElement={<Child {...props} />} {...passed} />
    }

    wrapped._appReactType = Child?._appReactType
    return wrapped;
}